export var NPS_CUSTOM_THEME = {
    themeName: "default",
    colorPalette: "light",
    isPanelless: false,
    backgroundImage: "",
    backgroundImageFit: "cover",
    backgroundImageAttachment: "scroll",
    backgroundOpacity: 1,
    cssVariables: {
        "--sjs-editorpanel-backcolor": "rgba(250, 250, 250, 1)",
        "--sjs-questionpanel-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-font-family": "Roboto",
        "--sjs-font-size": "16px",
        "--sjs-base-unit": "8px",
        "--sjs-font-pagedescription-size": "20px",
        "--sjs-shadow-small": "3px 4px 3px 0px rgba(0, 0, 0, 0.3)",
        "--sjs-font-questiontitle-size": "20px",
        "--sjs-font-questiondescription-size": "14px",
        "--sjs-shadow-inner": "inset 1px 2px 2px 0px rgba(0,0,0,0.08)",
        "--sjs-border-default": "rgba(5, 5, 5, 0.12)",
        "--sjs-border-light": "rgba(0,0,0,0.07)",
        "--sjs-general-backcolor": "#ffffff",
        "--sjs-general-backcolor-dark": "#f5f6f7",
        "--sjs-general-backcolor-dim-light": "rgba(249, 249, 249, 1)",
        "--sjs-general-backcolor-dim-dark": "rgba(243, 243, 243, 1)",
        "--sjs-general-forecolor": "#1a1a1a",
        "--sjs-general-forecolor-light": "rgba(0,0,0,0.5)",
        "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
        "--sjs-secondary-backcolor": "#E7F0FF",
        "--sjs-secondary-backcolor-light": "rgba(231,240,255,0.5)",
        "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
        "--sjs-secondary-forecolor": "#3B5BDB",
        "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.3)",
        "--sjs-shadow-medium": "0px 4px 12px rgba(0,0,0,0.10)",
        "--sjs-shadow-large": "0px 8px 24px rgba(0,0,0,0.12)",
        "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0,0,0,0.08)",
        "--sjs-border-inside": "rgba(0,0,0,0.12)",
        "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-green": "rgba(25, 179, 148, 1)",
        "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
        "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-blue": "rgba(67, 127, 217, 1)",
        "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
        "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
        "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-article-font-xx-large-textDecoration": "none",
        "--sjs-article-font-xx-large-fontWeight": "700",
        "--sjs-article-font-xx-large-fontStyle": "normal",
        "--sjs-article-font-xx-large-fontStretch": "normal",
        "--sjs-article-font-xx-large-letterSpacing": "0",
        "--sjs-article-font-xx-large-lineHeight": "64px",
        "--sjs-article-font-xx-large-paragraphIndent": "0px",
        "--sjs-article-font-xx-large-textCase": "none",
        "--sjs-article-font-x-large-textDecoration": "none",
        "--sjs-article-font-x-large-fontWeight": "700",
        "--sjs-article-font-x-large-fontStyle": "normal",
        "--sjs-article-font-x-large-fontStretch": "normal",
        "--sjs-article-font-x-large-letterSpacing": "0",
        "--sjs-article-font-x-large-lineHeight": "56px",
        "--sjs-article-font-x-large-paragraphIndent": "0px",
        "--sjs-article-font-x-large-textCase": "none",
        "--sjs-article-font-large-textDecoration": "none",
        "--sjs-article-font-large-fontWeight": "700",
        "--sjs-article-font-large-fontStyle": "normal",
        "--sjs-article-font-large-fontStretch": "normal",
        "--sjs-article-font-large-letterSpacing": "0",
        "--sjs-article-font-large-lineHeight": "40px",
        "--sjs-article-font-large-paragraphIndent": "0px",
        "--sjs-article-font-large-textCase": "none",
        "--sjs-article-font-medium-textDecoration": "none",
        "--sjs-article-font-medium-fontWeight": "700",
        "--sjs-article-font-medium-fontStyle": "normal",
        "--sjs-article-font-medium-fontStretch": "normal",
        "--sjs-article-font-medium-letterSpacing": "0",
        "--sjs-article-font-medium-lineHeight": "32px",
        "--sjs-article-font-medium-paragraphIndent": "0px",
        "--sjs-article-font-medium-textCase": "none",
        "--sjs-article-font-default-textDecoration": "none",
        "--sjs-article-font-default-fontWeight": "400",
        "--sjs-article-font-default-fontStyle": "normal",
        "--sjs-article-font-default-fontStretch": "normal",
        "--sjs-article-font-default-letterSpacing": "0",
        "--sjs-article-font-default-lineHeight": "28px",
        "--sjs-article-font-default-paragraphIndent": "0px",
        "--sjs-article-font-default-textCase": "none",
        "--sjs-general-backcolor-dim": "#F5F5F5",
        "--sjs-primary-backcolor": "#143971",
        "--sjs-primary-backcolor-dark": "rgba(17, 49, 98, 1)",
        "--sjs-primary-backcolor-light": "rgba(20, 57, 113, 0.1)",
        "--sjs-primary-forecolor": "#ffffff",
        "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-special-red": "rgba(230, 15, 65, 1)",
        "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
        "--sjs-header-backcolor": "#1581D0",
        "--sjs-font-headertitle-color": "rgba(255, 255, 255, 1)",
        "--sjs-font-headerdescription-color": "rgba(222, 222, 222, 1)",
    },
    header: {
        height: 145,
        mobileHeight: 100,
        inheritWidthFrom: "survey",
        textAreaWidth: 0,
        backgroundImageFit: "cover",
        backgroundImageOpacity: 100,
        overlapEnabled: true,
        logoPositionX: "right",
        logoPositionY: "middle",
        titlePositionX: "left",
        titlePositionY: "top",
        descriptionPositionX: "left",
        descriptionPositionY: "bottom",
    },
    headerView: "advanced",
};
